module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyBAMAAABYG2ONAAAAD1BMVEXNKj7ecn////+BnohDb0034HfXAAAAJklEQVR4AWNhIBmMXC2jWka1CJKnZTSQR7WMahnNYgOvZVTLqBYAVK0BDTB0dX0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/hu.png
// module id = B98V
// module chunks = 0